module.exports = __webpack_public_path__ + "static/media/form1.3a1b02c1.png";